import { ChangeDetectionStrategy, Component, OnInit, signal, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';
import { QueryParams } from 'src/app/models/navigation/navigationParams.interface';
import { InLineControlFiltersModel } from 'src/app/models/filters/implementations/pageFilters/inLineControlFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';
import { FiltersService } from 'src/app/services/filters/filters.service';
import { PageWithFiltersEnum } from 'src/app/models/filters/pageWithFilters.enum';

@Component({
  selector: 'app-ai-in-line-control-page',
  templateUrl: './ai-in-line-control-page.component.html',
  styleUrls: ['./ai-in-line-control-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiInLineControlPageComponent implements OnInit {
  public inLineControlSubtitlePath = 'enterpriseAiDetectionPage.tabs.inLineControlSubtitle';
  public inLineControlTooltipLabelPath = 'enterpriseAiDetectionPage.tabs.inLineControlTooltip';
  public isAccountAuthorizedToViewDataInLineControl = false;

  public isLoading = signal<boolean>(false);
  public integration = signal<string>('');
  public pageFilters = signal<InLineControlFiltersModel | undefined>(undefined);
  public isFiltersMenuOpen = signal<boolean>(false);
  public totalItems = signal<number>(-1);

  private readonly _filtersService = inject(FiltersService);

  constructor(
    private readonly _featureFlagsService: FeatureFlagsService,
    private readonly _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isAccountAuthorizedToViewDataInLineControl = this._featureFlagsService.isFeatureEnabled(
      FeatureFlagTypes.InlinePrevention
    );

    const integrationId = this._activatedRoute.snapshot.queryParams[QueryParams.integration];
    if (integrationId) {
      this.integration.set(integrationId);
    }

    this._initializeFilters();
  }

  public tablesFiltersChange(selectedOptions: ISelectOption[]): void {
    const filters = this.pageFilters();

    if (filters) {
      filters.updateFilterFromUserSelection(undefined, selectedOptions);
    }
  }

  public onTotalItemsChange(totalItems: number): void {
    this.totalItems.set(totalItems);
  }

  private _initializeFilters(): void {
    const filters = this._filtersService.getFilters(PageWithFiltersEnum.InLineControl) as InLineControlFiltersModel;
    this.pageFilters.set(filters);
  }
}
